<template>
  <div  class="bbe-email" :class="{'bbe-email_reply': replyOpen}">
    <transition name="bbe-fade" appear>
      <loader-fly v-if="loaderRun" :fill="true"/>
    </transition>
    <EmailHeader
      v-if="!replyOpen"
      @forward="openForwardMessage"
      @reply="openReplyMessage"
    />
    <VuePerfectScrollbar
      @selectstart="selectstart"
      @mouseleave="onMouseLeave"
      @mouseenter="onClearInterval"
      class="bbe-email__scroll"
      ref="bbeScrollEmail"
      v-if="!replyOpen">
      <EmailMsg @setLoader="setLoader"/>
    </VuePerfectScrollbar>
    <transition name="bbe-fade">
      <div class="bbe-email-buttons" v-if="!replyOpen">
        <button
          v-if="allAddresses.display"
          class="bbe-button"
          @click="openReplyMessage()"
        >
          <i class="email-icon-share"/>
          Reply All
        </button>
        <button class="bbe-button" @click="openReplyMessage()">
          <i class="email-icon-share"/>
          Reply
        </button>
        <button class="bbe-button" @click="openForwardMessage()">
          <i class="email-icon-next"/>
          Forward
        </button>
      </div>
    </transition>
    <transition name="bbe-fade">
      <VuePerfectScrollbar class="bbe-email__scroll" ref="bbEmailScroll" v-if="replyOpen">
        <NewMailFullSize :replyMsg="true" :scrollParent="scrollElement"/>
      </VuePerfectScrollbar>
    </transition>
  </div>
</template>

<script>
import LoaderFly from '@/components/Main/Loaders/LoaderFly'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import EmailHeader from '@/components/Email/EmailHeader/EmailHeader'
import EmailMsg from '@/components/Email/EmailMsg/EmailMsg'
import generateBodyForward from '@/mixin/generateBodyForward'
import {get} from 'lodash'
import NewMailFullSize from '@/components/NewMail/NewMailFullSize/NewMailFullSize'
import routerPush from '@/mixin/routerPush'
import findEmails from '@/mixin/findEmails'
import allAddresses from '@/mixin/allAddresses'

export default {
  name: 'MainPageProfile',
  components: {
    NewMailFullSize,
    EmailHeader,
    EmailMsg,
    VuePerfectScrollbar,
    LoaderFly
  },
  mixins: [generateBodyForward, routerPush, findEmails, allAddresses],
  data () {
    return {
      scrollElement: false,
      loaderRun: false,
      replyOpen: false,
      timeout: null,
      select: false
    }
  },
  computed: {
    activeEmail: {
      get: function () {
        return this.$store.getters.activeEmail
      },
      set: function (data) {
        this.$store.dispatch('setActiveEmail', data)
      }
    },
    newMessage: {
      get: function () {
        return this.$store.getters.newMessage
      },
      set: function (data) {
        this.$store.dispatch('setNewMessage', data)
      }
    },
    activeTab () {
      return this.$store.getters.activeTab
    },
    activeUser () {
      return this.$store.getters.userInfo || this.$store.getters.activeUser
    }
  },
  methods: {
    openForwardMessage () {
      this.createBodyForward()
      if (this.$route.name !== 'MainPageEmail') {
        const tabName = this.activeTab.toLowerCase()
        this.routerPush({name: 'TabOpen', params: {tab: tabName}})
      }
    },
    openReplyMessage () {
      const subject = get(this.activeEmail, 'subject', '')
      const isReply = /re:/gmi.test(subject)
      const prefix = isReply ? '' : 'Re:'
      const body = this.generateBodyForward(this.activeEmail, prefix)
      this.newMessage.subject = body.subject
      this.newMessage.isHideMailingList = true
      this.newMessage.toEmail = this.allAddresses.toEmail
      this.newMessage.copy = this.allAddresses.copy
      this.newMessage.files = []
      this.newMessage.isForward = false
      this.replyOpen = true
      this.$nextTick(this.setScrollElement)
    },
    setLoader (data) {
      this.loaderRun = data
    },
    scrollUp () {
      const scroll = get(this.$refs, 'bbeScrollEmail.$el', false)
      if (!scroll) return
      scroll.scrollTop = 0
    },
    setScrollElement () {
      this.scrollElement = get(this.$refs, 'bbEmailScroll', false)
    },
    scrollCustom () {
      document.addEventListener('mouseup', this.onClearInterval)
    },
    selectstart () {
      this.select = true
    },
    onMouseLeave (e) {
      if (!this.select) return
      const getBoundingClientRect = this.$refs.bbeScrollEmail.$el.getBoundingClientRect()
      let clientY = e.clientY < getBoundingClientRect.top ? -7 : 5
      this.timeout = setInterval(() => this.$refs.bbeScrollEmail.$el.scrollBy(0, clientY), 0)
    },
    onClearInterval (e) {
      if (this.select && e.type === 'mouseup') {
        this.select = false
      }
      clearInterval(this.timeout)
    }
  },
  watch: {
    activeEmail (newEmail, oldEmail) {
      if (newEmail.id === oldEmail.id) return
      this.replyOpen = false
      this.scrollUp()
    }
  },
  mounted () {
    this.scrollCustom()
  },
  beforeMount () {
    if (!this.activeEmail.id) {
      const tabName = this.activeTab.toLowerCase()
      this.routerPush({name: 'TabOpen', params: {tab: tabName}})
    }
  },
  beforeDestroy () {
    document.removeEventListener('mouseup', this.onClearInterval)
  }
}
</script>

<style lang="scss" scoped>
  @import "../sass/variables";
  @import "../sass/mixins";

  .bbe-email {
    position: relative;
    display: flex;
    flex-direction: column;
    margin-bottom: 30px;
    height: 100%;
    transition: .2s;

    &_reply {
      padding-top: 0;
    }

    &__scroll {
      height: 100%;
      max-height: 100%;
      overflow: hidden;
    }

    &-buttons {
      position: relative;
      display: inline-grid;
      grid-template-columns: repeat(auto-fill, minmax(91px, auto));
      grid-gap: 16px;
      padding: 21px 30px;
      white-space: nowrap;

      &:after {
        @include line-after-top();
      }

      .email-icon-share {
        font-size: 14px;
        margin-right: 7px;
      }

      .email-icon-next {
        margin-right: 7px;
        font-size: 16px;

        &:before {
          margin: 0;
        }
      }
    }
  }

</style>

<style lang="scss">
  @import "../sass/variables";

  .bbe-email {
    .ps__rail-y.ps--clicking .ps__thumb-y, .ps__rail-y:focus > .ps__thumb-y,
    .ps__rail-y:hover > .ps__thumb-y,
    .ps .ps__thumb-y {
      width: 5px;
      background-color: $color-accent;
      z-index: 3;
    }

    .ps .ps__rail-y {
      background-color: transparent;
    }
  }

</style>



// WEBPACK FOOTER //
// src/containers/Email.vue